export const dataUtil = {
    getImageByUsageTypePortal,
    getProductPrice,
    groupServicesByMonth,
    groupBillingPeriod,
    getImageByUsageType,
}

function getImageByUsageTypePortal(creatives, type, ignoreFirstElement) {
    let imageSources = [];
    let creative = null;
    if (!creatives || creatives.length == 0)
        return [];
    var isExitType = false;
    if (type) {
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === type.toLowerCase()) {
                creative = element;
                isExitType = true;
            }
        });
    }
    if (!isExitType && !ignoreFirstElement) {
        creative = creatives[0];
    }
    if (creative) {
        let media = creative.media;
        if (media && media.length > 0) {
            media.forEach(m => {
                if (m.width > 50 && m.height > 50) {
                    imageSources.push({
                        url: m.url,
                        width: m.width,
                        height: m.height
                    })
                }
            });
        } else {
            imageSources.push({
                url: creative.url,
                width: creative.width,
                height: creative.height
            })
        }
    }
    return imageSources.length > 0 ? imageSources[0] : null;
}

export const usage_type = {
    offers: 'AVATAR',
    offers_merchant: 'AVATAR',
    offer_detail: 'AVATAR',
    offer_detail_merchant: 'AVATAR',
    offer_map: 'AVATAR',
    offer_map_merchant: 'AVATAR',
    offer_order: 'AVATAR',
    product_item: 'AVATAR',
    product_detail: 'AVATAR',
    refer_friend: 'MARKETING',
    catalog: 'AVATAR',
    business_logo: 'BUSINESS_APP_LOGO',
    wallet_image: "WALLET_IMAGE",
    landing_page_bg: "LANDING_PAGE_IMAGE",
    delivery_image: "DELIVERY_IMAGE",
    pickup_image: "PICKUP_IMAGE",
    direct_sale_image: "DIRECT_SALE_IMAGE",
    APP_LOGO: "APP_LOGO",
    merchants_image: 'AVATAR',
    carousel_image: 'CAROUSEL'
}

function getProductPrice(pricing) {
    if (pricing && pricing.length > 0) {
        pricing = pricing.sort(sortPrice);
    }
    var amount = 0;
    if (pricing && pricing.length > 0) {
        amount = pricing[0].price;
    }
    return amount;
}
function sortPrice(n1, n2) {
    if (n1.price > n2.price) {
        return 1;
    } else if (n1.price < n2.price) {
        return -1
    } else {
        return 0;
    }
}
function groupServicesByMonth(services) {
    let newService = {};
    if (services.length > 0) {
        services.forEach(element => {
            let service = element.service;
            if (service.price && service.price.billing_period && service.price.billing_period.uot == 'MONTH') {
                let duration = service.price.billing_period.duration;
                let servicePeriod = newService[duration] ? newService[duration] : [];
                servicePeriod.push(element);
                newService[duration] = servicePeriod;
            }
        });
    }
    return newService;
}

function groupBillingPeriod(services) {
    let period = [];
    if (services.length > 0) {
        services.forEach(element => {
            let service = element.service;
            if (service.price && service.price.billing_period && service.price.billing_period.uot == 'MONTH') {
                if (service.price.billing_period.duration) {
                    let periodExis = period.filter(p => {
                        return p == service.price.billing_period.duration
                    })
                    if(!periodExis || periodExis.length == 0){
                        period.push(service.price.billing_period.duration)
                    }
                }
            }
        });
    }
    return period;
}

function getImageByUsageType(creatives, type, ignoreFirstElement) {
    let imageSources = [];
    let creative = null;
    if (!creatives || creatives.length == 0)
        return [];
    var isExitType = false;
    if (type) {
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === type.toLowerCase()) {
                creative = element;
                isExitType = true;
            }
        });
    }
    // if (!isExitType && !ignoreFirstElement) {
    //     creative = creatives[0];
    // }
    //console.log("AAAAAAAAAA creative = ", creative);
    if (creative) {
        let media = creative.media;
        if (media && media.length > 0) {
            media.forEach(m => {
                if (m.width > 50 && m.height > 50) {
                    imageSources.push({
                        uri: m.url,
                        width: m.width,
                        height: m.height
                    })
                }
            });
        } else {
            imageSources.push({
                uri: creative.url,
                width: creative.width,
                height: creative.height
            })
        }
    }
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA");
    //console.log("AAAAAAAAAA imageSources:",imageSources);
    return imageSources;
}
